import Permissions from 'src/security/permissions';
import { i18n } from 'src/i18n';
// import config from 'src/config';
import {
  faChartLine,
  faChartBar,
  faTable,
  faCog,
  // faCreditCard,
  faHistory,
  faThLarge,
  faUserPlus,
  faFileInvoice,
  faBriefcase,
  faClock,
  faCreditCard,
  faArchive,
  faFileInvoiceDollar,
} from '@fortawesome/free-solid-svg-icons';

const permissions = Permissions.values;

export default [
  {
    path: '/',
    exact: true,
    icon: faThLarge,
    label: 'Home',
    permissionRequired: null,
  },

  // {
  //   path: '/dashboard',
  //   exact: true,
  //   icon: faChartLine,
  //   label: 'Dashboard',
  //   permissionRequired: null,
  // },

  {
    path: '/user',
    label: i18n('user.menu'),
    permissionRequired: permissions.userRead,
    permissionType: 'canViewUsers',
    icon: faUserPlus,
  },
  
  {
    path: '/audit-logs',
    icon: faHistory,
    label: i18n('auditLog.menu'),
    permissionRequired: permissions.auditLogRead,
    permissionType: 'isPartner',
    requiresRootPartner: true,
  },
  
  {
    path: '/settings',
    icon: faCog,
    label: i18n('settings.menu'),
    permissionRequired: permissions.settingsEdit,
    permissionType: 'canChangeWorkspaceSettings',
  },

  {
    path: '/max-bid-table',
    icon: faTable,
    // TODO i18n
    label: 'Max Bids',
    permissionRequired: null,
    permissionType: 'isPartner',
  },

  {
    path: '/program-logs',
    icon: faFileInvoice,
    // TODO i18n
    label: 'Program Logs',
    permissionRequired: null,
    permissionType: 'isPartner',
  },

  {
    path: '/leads',
    icon: faBriefcase,
    label: 'Leads',
    permissionRequired: null,
    permissionType: 'isAdmin',
  },

  {
    path: '/plan',
    permissionRequired: permissions.planRead,
    permissionType: 'canViewPayments',
    requiresBillingAccess: true,
    icon: faCreditCard,
    label: 'Billing',
  },

  {
    path: '/partnerConfig',
    permissionRequired: null,
    permissionType: 'isPartner',
    requiresRootPartner: true,
    label: 'Partner Config',
    icon: faArchive,
  },

  {
    path: '/billing-table',
    permissionRequired: null,
    permissionType: 'isPartner',
    requiresBillingAccess: true,
    label: 'Billing Table',
    icon: faFileInvoiceDollar,
  },

  {
    path: '/partner-audit-log',
    permissionRequired: null,
    permissionType: 'isPartner',
    requiresRootPartner: true,
    label: 'Partner Audit Log',
    icon: faHistory,
  },

  // {
  //   path: '/time-settings',
  //   icon: faClock,
  //   label: 'Time Settings',
  //   permissionRequired: null,
  //   permissionType: 'isAdmin',
  // },

  // {
  //   path: '/user-data',
  //   permissionRequired: permissions.userDataRead,
  //   icon: faChevronRight,
  //   label: i18n('entities.userData.menu'),
  // },

  // {
  //   path: '/daily-report',
  //   permissionRequired: permissions.dailyReportRead,
  //   icon: faChevronRight,
  //   label: i18n('entities.dailyReport.menu'),
  // },

  // {
  //   path: '/monthly-reports',
  //   permissionRequired: permissions.monthlyReportsRead,
  //   icon: faChevronRight,
  //   label: i18n('entities.monthlyReports.menu'),
  // },  

  // {
  //   path: '/ads',
  //   permissionRequired: permissions.adsRead,
  //   icon: faChevronRight,
  //   label: i18n('entities.ads.menu'),
  // }, 
].filter(Boolean);
